import React from 'react'

import PhatDropdown from 'components/formElements/PhatDropdown'

import { Option } from 'components/elements/ArchidektDropdown/types'

import Icon from 'components/elements/Icon'

import { HUMAN_PRICE_SOURCE, PRICE_NAMES, PRICE_ICON_NAMES, PRICE_COLORS, PRICE_SOURCE } from 'types/active'

import styles from './priceDropdown.module.scss'

type Props = {
  priceSource: number
  changePriceSource: (option: any) => void
  className?: string
  menuClassName?: string
  header?: React.ReactNode
}

const PriceDropdown = ({ priceSource, changePriceSource, header, className = '', menuClassName = '' }: Props) => {
  const priceSourceColor = PRICE_COLORS[priceSource]
  const priceSourceClass = PRICE_ICON_NAMES[priceSource]

  const options = Object.values(HUMAN_PRICE_SOURCE).reduce((acc, priceSourceId) => {
    const localColor = PRICE_COLORS[priceSourceId]
    const localClassName = PRICE_ICON_NAMES[priceSourceId]
    const name = PRICE_NAMES[priceSourceId]

    if (priceSourceId === PRICE_SOURCE.NONE) acc.push({ type: 'spacer' })

    acc.push({
      id: `${priceSourceId}`,
      onClick: () => changePriceSource(priceSourceId),
      label: (
        <>
          {priceSourceId !== PRICE_SOURCE.NONE && <Icon className={localClassName} style={{ color: localColor }} />}
          {priceSourceId === PRICE_SOURCE.NONE && <Icon name="cancel" style={{ color: localColor }} />}
          {name}
        </>
      ),
    })

    return acc
  }, new Array<Option>())

  const selectedLabel = (
    <label>
      {priceSource !== PRICE_SOURCE.NONE && <Icon className={priceSourceClass} style={{ color: priceSourceColor }} />}
      {priceSource === PRICE_SOURCE.NONE && <Icon name="cancel" style={{ color: priceSourceColor }} />}
    </label>
  )

  return (
    <PhatDropdown
      fixedMenu
      matchMenuWidthToParent
      header={header}
      options={options}
      value={priceSource}
      selectedLabel={selectedLabel}
      className={styles.container}
      triggerClassName={`${styles.dropdown} ${className}`}
      menuClassName={`${styles.menu} ${menuClassName}`}
    />
  )
}

export default PriceDropdown

type GroupProps = {
  priceSources: Props[]
  noLabel?: boolean
}

export const PriceDropdownGroup = ({ priceSources, noLabel }: GroupProps) => (
  <div className={styles.group}>
    {priceSources.map((priceSource, index) => (
      <PriceDropdown
        key={`${priceSource}-${index}`}
        header={!noLabel && index === 0 ? 'Price sources' : undefined}
        priceSource={priceSource.priceSource}
        changePriceSource={priceSource.changePriceSource}
        className={
          index === 0
            ? styles.priceSourceOne
            : index === priceSources.length - 1
              ? styles.priceSourceLast
              : styles.priceSourceMiddle
        }
      />
    ))}
  </div>
)
